module.exports = __webpack_public_path__ + "static/media/Big-Boost-Logo-Two-Lines-Gold-Text-568x352.93bbc628.png";